var _this = this;
import * as tslib_1 from "tslib";
import { OptimizelyActionTypes } from './types';
export var initializeOptimizelyTourOperatorCodes = function () {
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var sessionCodes, a, action;
        return tslib_1.__generator(this, function (_a) {
            sessionCodes = window['optimizely_tour_operator_codes'];
            if (sessionCodes) {
                a = {
                    type: OptimizelyActionTypes.CHANGE_TOUR_OPERATOR_CODES,
                    tourOperatorCodes: sessionCodes
                };
                return [2 /*return*/, dispatch(a)];
            }
            action = {
                type: OptimizelyActionTypes.CHANGE_TOUR_OPERATOR_CODES,
                tourOperatorCodes: ''
            };
            return [2 /*return*/, dispatch(action)];
        });
    }); };
};
